import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the first CTA has scrolled out of view upwards.
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-27" data-mp="2fsl7l732vzuq">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink-950/95 px-3 pb-3 pt-3 backdrop-blur-md" data-id="element-28" data-mp="2aw3388bnu3ix">
          <div className="mx-auto flex max-w-2xl items-center gap-3" data-id="element-29" data-mp="2z2r2y8fzi14x">
            <div className="hidden shrink-0 leading-tight sm:block" data-id="element-30" data-mp="332hr04e4m35r">
              <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-white/40" data-id="element-31" data-mp="2pce7hl6msnk0">
                Solo oggi
              </p>
              <p className="font-display text-2xl text-brand-400" data-id="element-32" data-mp="2u9xxficoyors">€19</p>
            </div>
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="flex flex-1 animate-shake items-center justify-center rounded-2xl bg-brand-500 px-4 py-3.5 text-center text-[14px] font-black uppercase leading-tight tracking-tight text-ink-950 shadow-[0_10px_30px_-8px_rgba(23,195,178,0.8)] transition-colors duration-150 ease-out hover:bg-brand-400 sm:text-base" data-id="element-33" data-mp="2fcx45aeuqlr7">
              Voglio il Sistema — €19
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}